import { Select } from "antd";
import { useState } from "react";

const ENDPOINT_OPTIONS =
  "Survival|Overall survival|Progression-free survival|Relapse-free survival|Disease-free survival|Event-free survival|Recurrence-free survival|Survival rate|Progression|Disease progression|Time to progression|Relapse|Local Neoplasm Recurrence|Neoplasm, Residual|Recurrence|Response|Response rate|Complete response|Stable disease|Partial response|Duration of response|Pathological complete response|Pathologic complete response|Complete pathological response|Complete pathologic response|Objective response|Objective response rate|Minimal residual disease|Time to treatment failure|Time to next treatment|Time-to-Treatment|Length of the off treatment|Duration of the off treatment|Treatment failure|Remission|Remission induction|Death|Mortality|Metastasis|Major hematologic response|Durable complete remission rate|Durable complete response rate|Minimal residual disease response rate |Durable objective overall response rate|Metastasis-free survival|Failure-free survival|Cancer-specific survival|time off treatment|cancer progression|tumor regression|tumour regression|cancer regression|Risk of death|Tumor growth|tumour growth|Failure-free survival|Tumor mass|tumour volume|Cancer volume|Tumor weight|tumour weight|Tumor incidence|tumour incidence|Xenograft growth|Xenograft volume|Xenograft weight|Xenograft incidence|Apoptosis|Proliferat*|Cell proliferation|Ki-67|Proliferation index|Colony formation|Anti-proliferative activity|Anti-tumor activity|anti-tumour activity|Antitumor activity|antitumour activity|Anti-tumor effect|anti-tumour effect|Invasiveness|Invasion|Number of invasive cells|Cytotoxicity|Viability|Cell viability|Biochemical progression|Biochemical-Failure-Free-Survival |biochemical failure|biochemical recurrence|time to radiographic progression|PSA|Prostate specific antigen|Prostate-specific antigen|Serum asparaginase|Plasma testosterone levels|Durable major molecular response|Plasma levels of testosterone|antiproliferative|disease stabilization|volume reduction|Radiographic progression free survival|Biochemical relapse-free survival|";

const ENDPOINT_OPTIONS_LIST = ENDPOINT_OPTIONS.split("|");

const SelectEndpoint = (props) => {
  const [state, setState] = useState({
    endpointList: ENDPOINT_OPTIONS_LIST,
    query: "",
  });

  const onSearch = (value) => {
    setState({
      ...state,
      query: value,
      endpointList: ENDPOINT_OPTIONS_LIST.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      ),
    });
  };

  return (
    <Select
      showSearch
      allowClear
      onSearch={onSearch}
      style={{ width: "100%" }}
      placeholder="Select endpoint"
      //   defaultValue={props.defaultValue}

      onChange={props.onChange}
      tokenSeparators={[","]}
      options={state.endpointList.concat([state.query]).map((item) => ({
        value: item,
      }))}
    />
  );
};

export default SelectEndpoint;
